@import "~@govbr-ds/core/src/components/select/select";
@import "~@govbr-ds/core/src/components/item/item";

:host {
  display: block;

  .br-select br-list {
    background-color: var(--bg-color);
    box-shadow: var(--select-shadow);
    margin-top: -2px;
    max-height: 404px;
    overflow: auto;
    position: absolute;
    resize: none;
    width: 100%;
    z-index: 1;

    @include scrollbar;

    &:focus,
    &:active {
      color: var(--color-secondary-09);
      outline: none;
    }

    &:hover {
      &::-webkit-scrollbar-thumb {
        background: var(--color-secondary-07);
      }
    }

    .br-item br-radio::part(radio-input) {
      visibility: hidden;
      height: 0;
      width: 0;
    }

    .br-item br-radio::part(radio-label) {
      padding-left: var(--spacing-scale-base);
      position: relative;

      &::before,
      &::after {
        display: none;
      }
    }
  }
}
